import { useEffect } from 'react';

export const useOnGatekeeperRequestError = ({ statusCode, onGatesClosed, onGatesOpened }) => {
    useEffect(() => {
        if (statusCode) {
            const [typeOfCode] = statusCode.toString();
            switch (typeOfCode) {
                case '4':
                    onGatesClosed();
                    break;
                case '5':
                    onGatesOpened();
                    break;
                default:
            }
        }
    }, [statusCode]);
};
